class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.dropdownContainer = document.createElement('div');
    this.dropdownContainer.className = 'dropdown-container';
    this.dropdownContainer.style.display = 'none';
    this.appendChild(this.dropdownContainer);

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const searchResults = JSON.parse(text); // Assuming server returns JSON data
        console.log('xxxxxzwae: ' + searchResults)
        // Construct HTML table with search results
        let tableHtml = '<table>';
        searchResults.forEach((result) => {
          tableHtml += `<tr><td>${result}</td></tr>`;
        });
        tableHtml += '</table>';

        this.dropdownContainer.innerHTML = tableHtml;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.dropdownContainer.style.display = 'block';
  }

  close() {
    this.dropdownContainer.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
